import { render } from "./Popular.vue?vue&type=template&id=861ea3b2"
import script from "./Popular.vue?vue&type=script&lang=js"
export * from "./Popular.vue?vue&type=script&lang=js"

import "./Popular.vue?vue&type=style&index=0&id=861ea3b2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__